
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketing-destination-details/[slug]",
      function () {
        return require("private-next-pages/marketing-destination-details/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketing-destination-details/[slug]"])
      });
    }
  